import Api from '../api/Api';
import { useMutation } from '@tanstack/react-query';
import { ShoppingResult } from '../types/shopping';
import useAuthStore from '../store/authStore';

export default function useGetShoppingCartMutation() {
  const isAuthenticated = useAuthStore((store) => store.isAuthenticated());

  return useMutation({
    mutationFn: async ({
      checkStatus,
      withPrice,
    }: {
      checkStatus: boolean;
      withPrice: boolean;
    }): Promise<ShoppingResult> => {
      if (!isAuthenticated) return { shoppingItems: {} } as ShoppingResult;

      try {
        return await Api.shopping.GetShoppingCart(checkStatus, withPrice);
      } catch (error) {
        console.error('Error fetching shopping cart:', error);
        throw error;
      }
    },
  });
}
